/*@ngInject*/
const AdminFunctionHeaderButtonsController = function ($state, headerUtil, adminFunctionHeaderButtonsMediator, userType, navigationStateModel, adminFunctionHeaderButtonsModel) {

    this.tabList = [];

    this.loadAvailableActions = function () {
        adminFunctionHeaderButtonsMediator.getAvailableAdminFunctions().then((actions) => {
            _.each(actions, (value, key) => {
                let item = {};
                item.name = key;
                item.subTabs = actions[key];
                this.tabList.push(item);
            });
        });
    };

    this.isNavElementDisabled = function (tabName, subTabName) {
        return !adminFunctionHeaderButtonsModel.getStateMappings(tabName, subTabName);
    };

    this.isNavElementSelected = function (name) {
        let active = false;
        _.each(adminFunctionHeaderButtonsModel.navigationMappings[name], (state) => {
            if (headerUtil.isActiveNavElement(state.state)) {
                active = true;
                return false;
            }
        });
        return active;
    };

    this.onNavigationItemClick = function (tabName, subTabName) {
        const newState = adminFunctionHeaderButtonsModel.getStateMappings(tabName, subTabName);

        let userState,
            navigationState;

        if (newState.state === 'userList') {
            userState = `${newState.state}:${newState.params.userType}`;
            navigationState = navigationStateModel.restoreViewState(userState);
        } else {
            navigationState = navigationStateModel.restoreViewState(newState.state);
        }

        if (!_.isNil(navigationState)) {
            if (navigationState.parentState === newState.state || navigationState.parentState === userState) {
                if (!_.isNil(navigationState.currentState) && !_.isNil(navigationState.data)) {
                    $state.go(navigationState.currentState, navigationState.data);
                }
            }
        } else {
            $state.go(newState.state, newState.params);
        }

    };

    this.loadAvailableActions();
};

angular.module('gw-um-header')
    .controller('adminFunctionHeaderButtonsController', AdminFunctionHeaderButtonsController);
